'use client';

import { c as _c } from "react/compiler-runtime";
import { HTMLAttributes, forwardRef, useEffect, useState } from 'react';
export const ScreenHeightDiv = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>((t0, ref) => {
  const $ = _c(10);
  let other;
  let style;
  if ($[0] !== t0) {
    ({
      style,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = other;
    $[2] = style;
  } else {
    other = $[1];
    style = $[2];
  }
  const height = use100vh();
  const t1 = height ? `${height}px` : "100vh";
  let t2;
  if ($[3] !== style || $[4] !== t1) {
    t2 = {
      ...style,
      height: t1
    };
    $[3] = style;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const styleWithRealHeight = t2;
  let t3;
  if ($[6] !== other || $[7] !== ref || $[8] !== styleWithRealHeight) {
    t3 = <div ref={ref} style={styleWithRealHeight} {...other} />;
    $[6] = other;
    $[7] = ref;
    $[8] = styleWithRealHeight;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
});
ScreenHeightDiv.displayName = 'ScreenHeightDiv';
function use100vh() {
  const $ = _c(3);
  const [height, setHeight] = useState(measureHeight);
  const wasRenderedOnClientAtLeastOnce = useWasRenderedOnClientAtLeastOnce();
  let t0;
  let t1;
  if ($[0] !== wasRenderedOnClientAtLeastOnce) {
    t0 = () => {
      if (!wasRenderedOnClientAtLeastOnce) {
        return;
      }
      const setMeasuredHeight = function setMeasuredHeight() {
        const measuredHeight = measureHeight();
        setHeight(measuredHeight);
      };
      window.addEventListener("resize", setMeasuredHeight);
      return () => window.removeEventListener("resize", setMeasuredHeight);
    };
    t1 = [wasRenderedOnClientAtLeastOnce];
    $[0] = wasRenderedOnClientAtLeastOnce;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return wasRenderedOnClientAtLeastOnce ? height : null;
}
function measureHeight(): number | null {
  if (!isClient()) return null;
  return window.innerHeight;
}
function useWasRenderedOnClientAtLeastOnce() {
  const $ = _c(2);
  const [wasRenderedOnClientAtLeastOnce, setWasRenderedOnClientAtLeastOnce] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      if (isClient()) {
        setWasRenderedOnClientAtLeastOnce(true);
      }
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return wasRenderedOnClientAtLeastOnce;
}
export function isClient() {
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}